import React from 'react';
import { useOfficeData } from './useOfficeData';

export const OfficeSettings = () => {
  const { data: officeData, loading } = useOfficeData();

  return (
    <div className="w-full h-full overflow-y-auto bg-gray-50">
      <div className="p-6 max-w-3xl">
      <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">

        <div className="p-4 md:p-6 space-y-4">
          {(() => {
            const physical = officeData?.qualification?.physical || {};
            const contact = officeData?.contact || {};
            const officeName = physical?.socialName || physical?.name || officeData?.name || 'Nenhum cliente marcado';
            const officeCpf = physical?.cpf || officeData?.cpf || '—';
            const officeEmail = contact?.email || officeData?.email || '—';
            const officePhone = contact?.phonePrimary || contact?.phone || officeData?.phone || '—';

            return (
              <>
                <div className="rounded-lg border border-amber-300 bg-amber-50 text-amber-900 px-4 py-3 text-sm">
                  Os dados do escritório agora são lidos exclusivamente do cadastro de Clientes. Para alterar essas informações, edite o seu cadastro de Pessoa Física e marque a opção de escritório.
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="rounded-lg border border-slate-200 bg-slate-50 px-4 py-3">
                    <div className="text-[11px] font-bold uppercase tracking-widest text-slate-500">Cadastro marcado como escritório</div>
                    <div className="mt-2 text-sm font-semibold text-[#20243B]">{loading ? 'Carregando...' : officeName}</div>
                    <div className="mt-1 text-xs text-slate-600">CPF: {officeCpf}</div>
                    <div className="text-xs text-slate-600">E-mail: {officeEmail}</div>
                    <div className="text-xs text-slate-600">Telefone: {officePhone}</div>
                  </div>

                  <div className="rounded-lg border border-slate-200 bg-slate-50 px-4 py-3">
                    <div className="text-[11px] font-bold uppercase tracking-widest text-slate-500">Como atualizar</div>
                    <div className="mt-2 text-sm text-slate-700">Abra a aba Clientes, edite o seu cadastro Pessoa Física e ative o marcador "Este cadastro é o escritório (SSOT)".</div>
                  </div>
                </div>
              </>
            );
          })()}
        </div>
      </div>
      </div>
    </div>
  );
};
